// extracted by mini-css-extract-plugin
export default {"priceBlock":"TotalPrice_priceBlock__t3fT1","price":"TotalPrice_price__BbpHZ","orderButton":"TotalPrice_orderButton__UhEdf"};